import * as types from "../../../databse/types";

const initialState = {
    profile: {},
    rank : {}, 
    token: !!localStorage.getItem('token') ? localStorage.getItem('token') : false,
    address: [],
    activeAddress: JSON.parse(localStorage.getItem('activeAddress')) ? JSON.parse(localStorage.getItem('activeAddress')) : {},
};
const user = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PROFILE_USER':
            const createActiveAddress = {
                address: action.info.address,
                addressId: action.info.addressId,
                district: action.info.district,
                glat: action.info.glat,
                glng: action.info.glng,
            };
            const userRank = {
                'average_rank' : action.info.average_rank, 
                'count_rank' : action.info.count_rank, 
                'return_period' : action.info.return_period, 
                'rank' : action.info.rank, 
                'total_score' : action.info.total_score, 
            };
            if (!JSON.parse(localStorage.getItem('activeAddress')) && action.info.address && action.info.addressId) {
                localStorage.setItem('activeAddress', JSON.stringify(createActiveAddress));
                return {...state, profile: action.info, rank: userRank, activeAddress: createActiveAddress};
            } else {
                return {...state, profile: action.info, rank: userRank};
            }
        case 'EDIT_PROFILE_USER':
            return {...state, profile: {...state.profile, ...action.data}};
        case 'SET_TOKEN_USER':
            localStorage.setItem('token', action.token);
            return {...state, token: action.token};
        case 'GET_ADDRESS_USER':
            return {...state, address: action.address};
        case 'LOG_OUT':
            localStorage.removeItem('token');
            localStorage.removeItem('activeAddress');
            return {...initialState, token: false, activeAddress: {}};
        case 'SELECT_ITEM_ACTIVE_ADDRESS':
            localStorage.setItem('activeAddress', JSON.stringify(action.activeAddress));
            return {...state, activeAddress: action.activeAddress};
        case types.ADDRESS_REMOVE_ITEM_ADDRESS:
            return {
                ...state, address: state.address.filter(item => {
                    return item.addressId !== action.address.addressId ? item : '';
                })
            };
        default:
            return state;
    }
};

export default user;
